import { RouteConfig } from 'vue-router'
import { integrationRoutes } from '../constants/agency/'
import { requireAuth } from '../auth'

const Integration = () =>
  import('@/pmd/pages/agency/Integration.vue').then(m => m.default)

export const integration: RouteConfig[] = [
  {
    path: '/integration',
    component: Integration,
    name: integrationRoutes.default,
    beforeEnter: requireAuth,
    children: [
      {
        path: 'permissions',
        name: integrationRoutes.appPermissions,
        component: Integration,
        beforeEnter: requireAuth,
      },
      {
        path: 'settings',
        name: integrationRoutes.settings,
        component: Integration,
        beforeEnter: requireAuth
      },
      {
        path: ':appId/upgrade-plans',
        name: integrationRoutes.appUpgradePlans,
        component: Integration,
        beforeEnter: requireAuth,
      },
      {
        path: ':appId/update-app',
        name: integrationRoutes.updateApp,
        component: Integration,
        beforeEnter: requireAuth,
      },
      {
        path: ':appId/versions/:versionId',
        name: integrationRoutes.appVersion,
        component: Integration,
        beforeEnter: requireAuth,
      },
      {
        path: ':appId',
        name: integrationRoutes.appAnyApp,
        component: Integration,
        beforeEnter: requireAuth,
      },
      {
        path: ':pathMatch(.*)*',
        name: integrationRoutes.notFound,
        component: Integration,
        beforeEnter: requireAuth,
      },
    ],
  },
]
